import axios, { AxiosRequestConfig } from "axios";

export const getRFID = async (token: string) => {
  var config: AxiosRequestConfig = {
    method: "get",
    url: "https://pis.distronix.in:5443/api/rfidMaster/getAll",
    headers: {
      "x-access-token": token,
    },
  };

  const result = await axios(config).catch(function (error) {
    console.log(error);
  });

  return result;
};
